/**
 * Touch-Optionen für Swiper 3.x (jQuery-Plugin).
 * passiveListeners: false ist nötig, damit horizontaler Swipe auf iOS
 * nicht vom vertikalen Page-Scroll „geschluckt“ wird.
 */
export function getSwiperTouchOptions() {
  return {
    simulateTouch: true,
    touchRatio: 1,
    touchAngle: 45,
    shortSwipes: true,
    longSwipes: true,
    followFinger: true,
    touchMoveStopPropagation: false,
    passiveListeners: false,
    resistance: true,
    resistanceRatio: 0.85
  }
}
